var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"misa-notif-top-slot"}}),_c('router-view'),_c('div',{attrs:{"id":"message-box"}}),_c('ms-message-notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }